export default {
    car: 'Lånebevis Bil',
    carElectric: 'Lånebevis Elbil',
    carNoInsurance: 'Lånebevis Kaskofri Bil',
    mc: 'Lånebevis MC',
    atv: 'Lånebevis ATV',
    snowmobile: 'Lånebevis Snøscooter',
    campingCar: 'Lånebevis Bobil',
    campingCaravan: 'Lånebevis Campingvogn',
    boat: 'Lånebevis Båt',
};
